import React, { Component } from "react";
import { Table, Container } from "@amzn/awsui-components-react";
import TrailblazerTableData from "../data/TrailblazerTableData";

/**
 * This component renders the Trailblazer route hops as a table.
 */
export default class TrailblazerTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableDataManager: null
        };
    }

    componentDidMount() {
        this.processRouteData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.route !== this.props.route) {
            this.processRouteData();
        }
    }

    processRouteData() {
        if (!this.props.route || !this.props.route.hops) {
            this.setState({ tableDataManager: null });
            return;
        }

        this.setState({
            tableDataManager: new TrailblazerTableData(this.props.route)
        });
    }

    /**
     * Renders the header displaying the route metadata.
     */
    renderHeader = () => {
        const { tableDataManager } = this.state;

        if (!tableDataManager || !tableDataManager.hasMetadata()) {
            return (
                <Container>
                    Missing metadata for route.
                </Container>
            );
        }

        // iterates and renders all the metadata elements
        const metadataEntries = tableDataManager.getRenderedMetadata().map(({
            key, displayName, renderedValue
        }) => (
            <p key={key}>
                <strong>{displayName}:</strong> {renderedValue}
            </p>
        ));

        return (
            <Container>
                <h3>Route Information</h3>
                <div>
                    {metadataEntries}
                </div>
            </Container>
        );
    }

    renderHopTable = () => {
        const { tableDataManager } = this.state;

        if (!tableDataManager) {
            return (
                <Container>
                    <h3>Hop Details</h3>
                    <div>No hops in this route</div>
                </Container>
            );
        }

        const { tableItems, columnDefinitions, columnDisplay } = tableDataManager.getTableData();

        return (
            <Container>
                <h3>Hop Details</h3>
                <Table
                    items={tableItems}
                    columnDefinitions={columnDefinitions}
                    trackBy="id"
                    columnDisplay={columnDisplay}
                    empty={
                        <div>No hops in this route</div>
                    }
                    resizableColumns
                />
            </Container>
        );
    }

    render() {
        const { route } = this.props;

        if (!route) {
            return <div>No route data available</div>;
        }

        return (
            <div>
                {this.renderHeader()}
                {this.renderHopTable()}
            </div>
        );
    }
}